import { useEffect, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'

export function Callback() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [status, setStatus] = useState<'processing' | 'success' | 'error'>('processing')
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    const error = searchParams.get('error')
    if (error) {
      setStatus('error')
      setErrorMessage(error)
      return
    }

    // Check if we have a hash with token (from redirect)
    if (window.location.hash) {
      // Token is in hash, wait for it to be processed
      setTimeout(() => {
        navigate('/profile')
      }, 100)
    } else {
      // No hash, check if we were redirected from callback
      const checkAuth = async () => {
        try {
          const res = await fetch('/profile', { credentials: 'include' })
          if (res.ok) {
            navigate('/profile')
          }
        } catch {
          // Not authenticated yet
        }
      }
      checkAuth()
    }
  }, [searchParams, navigate])

  if (status === 'error') {
    return (
      <div className="callback">
        <div className="callback-card error">
          <h2>Error</h2>
          <p>{errorMessage}</p>
          <button onClick={() => navigate('/')} className="back-button">
            Volver al inicio
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="callback">
      <div className="callback-card">
        <div className="spinner large"></div>
        <h2>Procesando...</h2>
      </div>
    </div>
  )
}
